import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Flex,
  Text,
  VStack,
  HStack,
  Tooltip,
  Spinner,
  useTheme,
  useColorMode,
  Link
} from "@chakra-ui/react";
import dialogManager from "../DialogManager/DialogManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
  
} from "@fortawesome/free-solid-svg-icons";
import { cqAPI } from "../../lib/Auth";
import UpcomingInvoice from "./UpcomingInvoice";
import "./Invoices.css";

function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const theme = useTheme();
  const { colorMode } = useColorMode();
  const fetchInvoices = async () => {

    try {

      const response = await cqAPI.get(
        `/invoices`
      );
      if (response.type === 'ok'){
        setInvoices(response.data);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };


  useEffect(() => {
    fetchInvoices();
  }, []);

  
  const hoverBgColor =
    colorMode === "light" ? theme.colors.gray[50] : theme.colors.gray[700];

  return (
    <Box p={4} overflowY="auto" maxHeight="100vh" width="100%">
      <VStack spacing={4} align="stretch">
        <UpcomingInvoice />
        <Flex borderBottom="1px" borderColor="gray.200" p={2}>
          <HStack spacing={8} flex="1">
            <Text
              fontSize="sm"
              flexBasis="20%"
              fontWeight="bold"
              cursor="pointer"
            >
              Period
            </Text>
            <Text
              fontSize="sm"
              flexBasis="15%"
              fontWeight="bold"
              cursor="pointer"
            >
              Due Date
            </Text>
            <Text
              fontSize="sm"
              flexBasis="15%"
              fontWeight="bold"
              cursor="pointer"
            >
              Status
            </Text>
            <Text
              fontSize="sm"
              flexBasis="15%"
              fontWeight="bold"
              cursor="pointer"
            >
              Amount
            </Text>
          </HStack>
        </Flex>
        {invoices.map((invoice) => (
          <Flex
            id={`invoice-row-${invoice.id}`}
            key={invoice.id}
            p={2}
          >
            <HStack spacing={8} flex="1">
              <Box fontSize="sm" flexBasis="20%">
                <Link href={invoice.pdf_link} target="_blank">{moment(invoice.period_start * 1000).format("MMM D, YYYY")} - {moment(invoice.period_end * 1000).format("MMM D, YYYY")}</Link>
                {invoice.description && (
                  <Text fontSize="xs" color={colorMode === "light" ? "gray.600" : "gray.300"} whiteSpace="pre-wrap" data-testid={`invoice-description-${invoice.id}`}>
                    {invoice.description}
                  </Text>
                )}
              </Box>
              <Text fontSize="sm" flexBasis="15%">
                {invoice.due_date? moment(invoice.due_date * 1000).format("MMM D, YYYY") : 'N/A'}
              </Text>
              <Text fontSize="sm" flexBasis="15%">
                {invoice.status}
              </Text>
              <Text fontSize="sm" flexBasis="15%">
                ${(invoice.amount_due / 100).toFixed(2)}
              </Text>
            </HStack>
          </Flex>
        ))}
      </VStack>        
    </Box>
  );
}

export default Invoices;
